const popupMessages = {
  health_1: 'תקשיבו, שרירי ליבה זה חשוב! רוצים לחזק אותם? ',
  health_2: 'לחצו כאן ואתם כבר בדרך...',
  health_btn: 'אני רוצה!',

  pension_1: 'שרק תהיו לנו בריאים! ארגנו לכם ביטוח בריאות במימון מלא,',
  pension_2: 'זה מעולה!',
  pension_btn: 'אני רוצה!',

  allAround_1: 'הדבר הכי נדיר שיש – חניה! אז יש לכם...',
  allAround_2: '',
  allAround_btn: `מה הקאצ'?`,

  food_1:
    'Cibus – ברור. אבל איך זה עובד מהבית? ומה קרה אם דווקא אתמול בישלתי? חשבנו גם על זה...',
  food_2: '',
  food_btn: 'תפתיעו אותי!',

  workingInSpace_1: 'אתם חלק מ"שכונה", סתם שתדעו!',
  workingInSpace_2: '',
  workingInSpace_btn: 'מה זה אומר?!',

  important_1: `NICE  שואפת להיות חלק אינטגרלי מהקהילה בה היא פועלת, ומקדישה מאמצים רבים לתרום לה לאורך כל השנה. החברה ממקדת את פעילותה החברתית בתחום קידום נערות ונשים בעולם הטכנולוגי, תוך השקעה רבה בתכנית "קודקודה" ובשיתופי פעולה עם עמותות וארגונים חברתיים הפועלים בתחום זה. בנוסף, נייס תורמת באופן שוטף מחשבים ניידים, ציוד אלקטרוני, ריהוט וציוד נוסף לעמותות וארגונים שונים לאורך כל השנה.`,
  important_2: `בכל שנה אנו מקיימים חודש התנדבות גלובלי במהלכו כל עובדי ועובדות החברה יוצאים לימי התנדבות בארגונים חברתיים שונים. לאורך השנה אנו מסייעים לעסקים מקומיים קטנים וחברתיים בשיתופי פעולה שונים ומגוונים.`,
}

export default popupMessages
